import { render } from "./SurveyHome.vue?vue&type=template&id=357050ec"
import script from "./SurveyHome.vue?vue&type=script&lang=js"
export * from "./SurveyHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__